import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, LocaleEnum, Units } from '@systemeio/types';
import { centsToUnits, units } from '@systemeio/util';
import { ChartData, ChartOptions } from 'chart.js';
import ChartBox from 'modules/main/components/chart-box-section/chart-box';
import ChartsSkeleton from 'modules/main/components/chart-box-section/charts-skeleton';
import { ChartBoxSectionProps } from 'modules/main/components/chart-box-section/types';
import { useMain } from 'modules/main/hooks/use-main';
import { MainRevenueInterface, MainRevenueItemInterface } from 'modules/main/types/main-interface';
import { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { lineChartOptions, lineChartPlugins, withTooltipTitles } from 'shared/components/chart/chart-config';
import { CurrencyNameEnum } from 'shared/enums/currency-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { currencyFormat } from 'shared/utils/currency-format';
import { toFullDate, toShortDate } from 'shared/utils/date-time-format';
export interface RevenueChartBoxProps extends ChartBoxSectionProps {}
export const getRevenueChartOptions = (currency: CurrencyEnum, locale?: LocaleEnum, tooltipTitles: string[] = []): ChartOptions<'line'> => {
  const options = withTooltipTitles<'line'>(lineChartOptions, tooltipTitles);
  return {
    ...options,
    plugins: {
      ...options.plugins,
      tooltip: {
        ...options.plugins?.tooltip,
        callbacks: {
          ...options.plugins?.tooltip?.callbacks,
          label: ({
            parsed
          }) => parsed.y === null ? '' : currencyFormat(units(parsed.y), currency, locale, true)
        }
      }
    }
  };
};
export const RevenueChartBox = t0 => {
  const $ = _c(17);
  const {
    filter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    revenue
  } = useMain(filter);
  const {
    user,
    intlLocale
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [revenueData, setRevenueData] = useState(t1);
  let t2;
  if ($[1] !== intlLocale || $[2] !== revenue) {
    t2 = () => {
      if (revenue) {
        setRevenueData((Object.keys(revenue) as Array<keyof MainRevenueInterface>).sort((a, b) => revenue[b].total - revenue[a].total).map(key => ({
          currency: key,
          data: revenue[key],
          chartData: {
            labels: revenue[key].values.map(value => toShortDate(value.date, intlLocale)),
            datasets: [{
              data: revenue[key].values.map(_temp)
            }]
          }
        })));
      }
    };
    $[1] = intlLocale;
    $[2] = revenue;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== intlLocale || $[5] !== revenue || $[6] !== t) {
    t3 = [revenue, intlLocale, t];
    $[4] = intlLocale;
    $[5] = revenue;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== filter || $[9] !== intlLocale || $[10] !== revenue || $[11] !== revenueData || $[12] !== t || $[13] !== user?.dashboardLocale) {
    t4 = revenue ? revenueData.map((rev, idx) => <ChartBox key={idx} title={t("dashboard.main.sales")} total={currencyFormat(Math.round(centsToUnits(rev.data.total)) as Units, rev.currency, user?.dashboardLocale, true)} diffPercents={rev.data.diffPercents} countDays={rev.data.countDays} dateSince={filter.dateSince} chart={<Line height={200} data={rev.chartData} options={getRevenueChartOptions(rev.currency, user?.dashboardLocale, rev.data.values.map(t5 => {
      const {
        date
      } = t5;
      return toFullDate(date, intlLocale);
    }))} plugins={lineChartPlugins} />} />) : <ChartsSkeleton />;
    $[8] = filter;
    $[9] = intlLocale;
    $[10] = revenue;
    $[11] = revenueData;
    $[12] = t;
    $[13] = user?.dashboardLocale;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = <>{t4}</>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
function _temp(t0) {
  const {
    value: value_0
  } = t0;
  return Math.round(value_0 / 100);
}